{
 "source": "BFS GWR, kodes_codes_codici.csv (public.madd.bfs.admin.ch), Stand 2026-09-27",
 "codes": {
  "GKAT": {
   "1010": "Provisorische Unterkunft",
   "1020": "Gebäude mit ausschliesslicher Wohnnutzung",
   "1030": "Andere Wohngebäude (Wohngebäude mit Nebennutzung)",
   "1040": "Gebäude mit teilweiser Wohnnutzung",
   "1060": "Gebäude ohne Wohnnutzung",
   "1080": "Sonderbau"
  },
  "GKLAS": {
   "1110": "Gebäude mit einer Wohnung",
   "1121": "Gebäude mit zwei  Wohnungen",
   "1122": "Gebäude mit drei oder mehr Wohnungen",
   "1130": "Wohngebäude für Gemeinschaften",
   "1211": "Hotelgebäude",
   "1212": "Andere Gebäude für kurzfristige Beherbergung",
   "1220": "Bürogebäude",
   "1230": "Gross-und Einzelhandelsgebäude",
   "1231": "Restaurants und Bars in Gebäuden ohne Wohnnutzung",
   "1241": "Gebäude des Verkehrs- und Nachrichtenwesens ohne Garagen",
   "1242": "Garagengebäude",
   "1251": "Industriegebäude",
   "1252": "Behälter, Silos und Lagergebäude",
   "1261": "Gebäude für Kultur- und Freizeitzwecke",
   "1262": "Museen und Bibliotheken",
   "1263": "Schul- und Hochschulgebäude, Forschungseinrichtungen",
   "1264": "Krankenhäuser und Facheinrichtungen des Gesundheitswesens",
   "1265": "Sporthallen",
   "1271": "Landwirtschaftliche Betriebsgebäude",
   "1272": "Kirchen und sonstige Kultgebäude",
   "1273": "Denkmäler oder unter Denkmalschutz stehende Bauwerke",
   "1274": "Sonstige Hochbauten, anderweitig nicht genannt",
   "1275": "Andere Gebäude für die kollektive Unterkunft",
   "1276": "Gebäude für die Tierhaltung",
   "1277": "Gebäude für den Pflanzenbau",
   "1278": "Andere landwirtschaftliche Gebäude"
  },
  "GBAUP": {
   "8011": "Periode vor 1919",
   "8012": "Periode von 1919 bis 1945",
   "8013": "Periode von 1946 bis 1960",
   "8014": "Periode von 1961 bis 1970",
   "8015": "Periode von 1971 bis 1980",
   "8016": "Periode von 1981 bis 1985",
   "8017": "Periode von 1986 bis 1990",
   "8018": "Periode von 1991 bis 1995",
   "8019": "Periode von 1996 bis 2000",
   "8020": "Periode von 2001 bis 2005",
   "8021": "Periode von 2006 bis 2010",
   "8022": "Periode von 2011 bis 2015",
   "8023": "Periode nach 2015"
  },
  "GSTAT": {
   "1001": "Gebäude projektiert",
   "1002": "Gebäude bewilligt",
   "1003": "Gebäude im Bau",
   "1004": "Gebäude bestehend",
   "1005": "Gebäude nicht nutzbar",
   "1007": "Gebäude abgebrochen",
   "1008": "Gebäude nicht realisiert"
  },
  "GWAERZH1": {
   "7400": "Kein Wärmeerzeuger",
   "7410": "Wärmepumpe für ein Gebäude",
   "7411": "Wärmepumpe für mehrere Gebäude",
   "7420": "Thermische Solaranlage für ein Gebäude",
   "7421": "Thermische Solaranlage für mehrere Gebäude",
   "7430": "Heizkessel (generisch) für ein Gebäude",
   "7431": "Heizkessel (generisch) für mehrere Gebäude",
   "7432": "Heizkessel nicht kondensierend für ein Gebäude",
   "7433": "Heizkessel nicht kondensierend für mehrere Gebäude",
   "7434": "Heizkessel kondensierend für ein Gebäude",
   "7435": "Heizkessel kondensierend für mehrere Gebäude",
   "7436": "Ofen",
   "7440": "Wärmekraftkopplungsanlage für ein Gebäude",
   "7441": "Wärmekraftkopplungsanlage für mehrere Gebäude",
   "7450": "Elektrospeicher-Zentralheizung für ein Gebäude",
   "7451": "Elektrospeicher-Zentralheizung für mehrere Gebäude",
   "7452": "Elektro direkt",
   "7460": "Wärmetauscher (einschliesslich für Fernwärme) für ein Gebäude",
   "7461": "Wärmetauscher (einschliesslich für Fernwärme) für mehrere Gebäude",
   "7499": "Andere"
  },
  "GENH1": {
   "7500": "Keine",
   "7501": "Luft",
   "7510": "Erdwärme (generisch)",
   "7511": "Erdwärmesonde",
   "7512": "Erdregister",
   "7513": "Wasser (Grundwasser, Oberflächenwasser, Abwasser)",
   "7520": "Gas",
   "7530": "Heizöl",
   "7540": "Holz (generisch)",
   "7541": "Holz (Stückholz)",
   "7542": "Holz (Pellets)",
   "7543": "Holz (Schnitzel)",
   "7550": "Abwärme (innerhalb des Gebäudes)",
   "7560": "Elektrizität",
   "7570": "Sonne (thermisch)",
   "7580": "Fernwärme (generisch)",
   "7581": "Fernwärme (Hochtemperatur)",
   "7582": "Fernwärme (Niedertemperatur)",
   "7598": "Unbestimmt",
   "7599": "Andere"
  },
  "GWAERZW1": {
   "7600": "Kein Wärmeerzeuger",
   "7610": "Wärmepumpe",
   "7620": "Thermische Solaranlage",
   "7630": "Heizkessel (generisch)",
   "7632": "Heizkessel nicht kondensierend",
   "7634": "Heizkessel kondensierend",
   "7640": "Wärmekraftkopplungsanlage",
   "7650": "Zentraler Elektroboiler",
   "7651": "Kleinboiler",
   "7660": "Wärmetauscher (einschliesslich für Fernwärme)",
   "7699": "Andere"
  },
  "GENW1": {
   "7500": "Keine",
   "7501": "Luft",
   "7510": "Erdwärme (generisch)",
   "7511": "Erdwärmesonde",
   "7512": "Erdregister",
   "7513": "Wasser (Grundwasser, Oberflächenwasser, Abwasser)",
   "7520": "Gas",
   "7530": "Heizöl",
   "7540": "Holz (generisch)",
   "7541": "Holz (Stückholz)",
   "7542": "Holz (Pellets)",
   "7543": "Holz (Schnitzel)",
   "7550": "Abwärme (innerhalb des Gebäudes)",
   "7560": "Elektrizität",
   "7570": "Sonne (thermisch)",
   "7580": "Fernwärme (generisch)",
   "7581": "Fernwärme (Hochtemperatur)",
   "7582": "Fernwärme (Niedertemperatur)",
   "7598": "Unbestimmt",
   "7599": "Andere"
  }
 }
}